import { formatCurrency } from "@commons-monorepo/index";
import { t } from "i18next";
import styles from "./FloatingButtonCart.module.css";
import { UiButton } from "@ui-monorepo/index";
import { useAnalytics } from "@commons-monorepo/index";
import { EVENTS } from "~/constants/events";
import { useCart } from "~/modules/cart/providers/cart.provider";
import { useEffect, useState } from "react";
import { productPrice } from "~/modules/cart/utils/product-cart.utils";
import { useOutletContext } from "@remix-run/react";

const FloatingButtonCart = () => {
  const isCheckout = location.pathname.includes("checkout");
  const { storeMetadata } = useOutletContext<any>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const { goToCheckout, cartProducts } = useCart();
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    const total = cartProducts.reduce((p, c) => {
      let wholesalePrice: number | undefined;
      if (c.wholesale?.configurations?.length) {
        wholesalePrice =
        c.quantity >= c.wholesale?.configurations[0].minUnits ?
        c.wholesalePrice :
        undefined;
      }
      return p + productPrice(c.price || 0, c.quantity, wholesalePrice);
    }, 0);
    setTotalPrice(total);
  }, [cartProducts]);

  const handleOpenCart = () => {
    if (cartProducts.length >= 1) {
      goToCheckout();
      logEvent(EVENTS.SELECT_GO_TO_CART_ALERT);
    }
  };

  const productsLength = () => {
    let total = 0;
    cartProducts.forEach((p) => {
      total += p.quantity;
    });
    return total;
  };

  return (
    <div className={styles.wrapperButtonCart} role='button-floating-cart'>
      <div className={styles.boxButton}>
        <div className={styles.floattingButton}>
          {!isCheckout ?
          <div className={styles.cartButtonWrapper} role='car-button-price'>
              <div
              className={
              cartProducts.length >= 1 ?
              styles.boxCartButton :
              styles.boxCartHide}>


                <div className={styles.cartButton}>
                  <p
                  className={
                  cartProducts.length >= 1 ?
                  styles.cartUnitsButton :
                  styles.cartUnitsHide}>


                    {productsLength()}
                    {productsLength() > 1 ?
                  ` ${t("category.products")}` :
                  ` ${t("category.product")}`}
                  </p>
                </div>
                <div
                className={
                cartProducts.length >= 1 ?
                styles.priceCart :
                styles.priceCartHide}>


                  <p className={styles.totalCart}>
                    {formatCurrency(totalPrice, {
                    locale: storeMetadata?.locale,
                    currency: storeMetadata?.currency
                  })}
                  </p>
                </div>
              </div>
            </div> :

          <div className='boxEmpty' />}

          <UiButton
            className={styles.payButton}
            onClick={handleOpenCart}
            role='open-cart'>

            <div className={styles.floatingBtn}>
              <>
                <span className='icon-cart-outline'></span>
                {t("cart.go_checkout")}
              </>
            </div>
          </UiButton>
        </div>
      </div>
    </div>);

};

export default FloatingButtonCart;